import { IMarkoutAccountRow } from '../markout.interface';
import { MARKOUT_ROW_ID_SEPARATOR } from '../markout.constant';

export const makeAccountRowId = (row: Pick<IMarkoutAccountRow, 'serverId' | 'accountId'>): string => {
  return `${row.serverId}${MARKOUT_ROW_ID_SEPARATOR}${row.accountId}`;
};

export const makeSymbolRowId = (
  serverId: string,
  accountId: string,
  symbolName: string,
): string => {
  return `${serverId}${MARKOUT_ROW_ID_SEPARATOR}${accountId}${MARKOUT_ROW_ID_SEPARATOR}${symbolName}`;
};
